type ChecklistState = Record<string, boolean>

function getStorageKey(checklistId: string) {
  return `babs:blog:${checklistId}:checklist`
}

function readState(checklistId: string): ChecklistState {
  if (typeof window === 'undefined') return {}

  try {
    const raw = window.localStorage.getItem(getStorageKey(checklistId))
    if (!raw) return {}

    const parsed = JSON.parse(raw) as unknown
    if (!parsed || typeof parsed !== 'object') return {}

    return Object.fromEntries(
      Object.entries(parsed).filter(([, value]) => typeof value === 'boolean'),
    )
  } catch {
    return {}
  }
}

function writeState(checklistId: string, state: ChecklistState) {
  if (typeof window === 'undefined') return

  try {
    window.localStorage.setItem(
      getStorageKey(checklistId),
      JSON.stringify(state),
    )
  } catch {
    // Keep the checklist usable when storage is unavailable.
  }
}

export function getBlogChecklistItem(
  checklistId: string,
  itemId: string,
): boolean {
  return readState(checklistId)[itemId] === true
}

export function setBlogChecklistItem(
  checklistId: string,
  itemId: string,
  checked: boolean,
) {
  const state = readState(checklistId)

  if (checked) {
    writeState(checklistId, { ...state, [itemId]: true })
    return
  }

  const { [itemId]: _removed, ...rest } = state
  writeState(checklistId, rest)
}
